import { ApiRequest } from "../../api/ApiRequest";
import { ApiPaths } from "../../api/ApiPaths";

export type GetInfoSuccessResponseType = {
    id: string,
    name: string,
    role: string,
    email: string
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getUserInfo(): Promise<GetInfoSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.authentication.user,
        {},
        () => {},
        () => {});
}
